import React, { createContext, useState, useContext, useCallback } from 'react';
import { startOfDay, endOfDay } from 'date-fns';

const ReportingContext = createContext();

export const ReportingProvider = ({ children }) => {
  const [reportingParams, setReportingParams] = useState({
    allCollectionPointsIds: [],
    collectionPointIds: [],
    additionalCollectionPointsIds: [],
    closestCommonParent: null,
    startAt: startOfDay(new Date(new Date().getFullYear(), 0, 1)),
    endAt: endOfDay(new Date()),
  });
  const [endAtManuallyChanged, setEndAtManuallyChanged] = useState(false);

  const updateReportingParams = (newParams) => {
    setReportingParams(prev => ({
      ...prev,
      ...newParams,
    }));
    // If endAt is being updated, mark it as manually changed
    if ('endAt' in newParams && newParams.endAt !== reportingParams.endAt) {
      setEndAtManuallyChanged(true);
    }
  };

  const updateEndDateWithoutMarking = useCallback((date) => {
    setReportingParams(prev => ({
      ...prev,
      endAt: endOfDay(date),
    }));
  }, []);

  return (
    <ReportingContext.Provider value={{ 
      reportingParams, 
      updateReportingParams, 
      endAtManuallyChanged,
      updateEndDateWithoutMarking 
    }}>
      {children}
    </ReportingContext.Provider>
  );
};

export const useReporting = () => {
  const context = useContext(ReportingContext);
  if (!context) {
    throw new Error('useReporting must be used within a ReportingProvider');
  }
  return context;
}; 